import clsx from "clsx";
import { useRef, useState } from "react";
import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { ReactComponent as Arrow } from "../../../assets/arrow.svg";
import { ReactComponent as SearchIcon } from "../../../assets/search.svg";
import ZoomModal from "./ZoomModal";
import style from "./style.module.scss";

const Gallery = ({ images = [] }) => {
  const [openModal, setOpenModal] = useState(false);
  const [imageToZoom, setImageToZoom] = useState(null);
  const mobileBreakpointInt = style.mobileBreakpoint.slice(0, 3);
  const tabletBreakpointInt = style.tabletBreakpoint.slice(0, 4);

  const [swiper1, setSwiper1] = useState();
  const [swiper2, setSwiper2] = useState();
  const [swiper1ActiveIndex, setSwiper1ActiveIndex] = useState(0);
  const swiperNextRef = useRef(null);
  const swiperPrevRef = useRef(null);

  const swiper1Props = {
    allowTouchMove: true,
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
      prevEl: swiperPrevRef.current,
      nextEl: swiperNextRef.current,
    },
    breakpoints: {
      [mobileBreakpointInt]: {
        allowTouchMove: false,
      },
    },
    modules: [Navigation],
  };

  const swiper2Props = {
    allowTouchMove: true,
    slidesPerView: 3,
    spaceBetween: 14,
    breakpoints: {
      [tabletBreakpointInt]: {
        slidesPerView: 4,
        spaceBetween: 26,
      },
    },
  };

  // Initialize the swiper with React refs
  const initSwiper = (swiper) => {
    // Delay execution for the refs to be defined
    setTimeout(() => {
      // Re-init navigation
      if (swiper.params?.navigation) {
        swiper.params.navigation.prevEl = swiperPrevRef.current;
        swiper.params.navigation.nextEl = swiperNextRef.current;
        swiper.navigation.destroy();
        swiper.navigation.init();
        swiper.navigation.update();
      }
    });
  };

  const handleSlideTo = (swiper, i) => {
    setSwiper1ActiveIndex(i ?? 0);
    swiper?.slideTo(i ?? 0, 500);
  };

  return (
    <>
      <div className={style.block}>
        <Swiper
          className={style.swiper1}
          {...swiper1Props}
          onSwiper={(swiper) => {
            initSwiper(swiper);
            setSwiper1(swiper);
          }}
        >
          {images?.length > 0 &&
            images.map((image) => (
              <SwiperSlide className={style.slide} key={image.id}>
                <img src={image.url} alt={image.alt} loading="lazy" />
              </SwiperSlide>
            ))}

          <div className={style.nav}>
            <div
              ref={swiperNextRef}
              className={style.arrowRight}
              onClick={() => handleSlideTo(swiper2, swiper1.activeIndex)}
            >
              <Arrow />
            </div>
            <div
              ref={swiperPrevRef}
              className={style.arrowLeft}
              onClick={() => handleSlideTo(swiper2, swiper1.activeIndex)}
            >
              <Arrow />
            </div>
          </div>

          {images?.length > 0 && (
            <div
              className={style.zoom}
              onClick={() => {
                setImageToZoom(images[swiper1ActiveIndex]);
                setOpenModal(true);
              }}
            >
              <SearchIcon />
            </div>
          )}
        </Swiper>

        <Swiper
          className={style.swiper2}
          {...swiper2Props}
          onSwiper={(swiper) => {
            initSwiper(swiper);
            setSwiper2(swiper);
          }}
        >
          {images?.length > 0 &&
            images.map((image, i) => (
              <SwiperSlide key={image.id}>
                <div
                  className={clsx(
                    style.imageContainer,
                    swiper1ActiveIndex === i && style.currentImage
                  )}
                  onClick={() => handleSlideTo(swiper1, i)}
                >
                  <img src={image.url} alt={image.alt} loading="lazy" />
                </div>
              </SwiperSlide>
            ))}
        </Swiper>
      </div>

      <ZoomModal
        open={openModal}
        handleClose={() => {
          setOpenModal(false);
          setImageToZoom(null);
        }}
        img={imageToZoom}
      />
    </>
  );
};

export default Gallery;
